import Field from '@rezdy/components/Form/Field';
import Password from '@rezdy/components/Password';
import TextStyle from '@rezdy/components/TextStyle';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import styled from 'styled-components';

interface ICreatePasswordProps extends WithTranslation {
    customLabel?: JSX.Element;
    label?: string;
    name?: string;
}

interface ICreatePasswordState {
    value: string;
    minCharsRule: boolean;
    caseRule: boolean;
    numberRule: boolean;
}

const PasswordTextRule = styled(TextStyle as any)`
    color: ${({ isDirty }) => (isDirty ? '#FA626F' : '#1958D6')};
`;

export class CreatePassword extends React.PureComponent<ICreatePasswordProps, ICreatePasswordState> {
    constructor(props: ICreatePasswordProps) {
        super(props);
        this.state = {
            caseRule: false,
            minCharsRule: false,
            numberRule: false,
            value: '',
        };
    }

    onChange = ({ value }: { value: string }) => {
        const minCharsRule = value.length >= 8;
        const caseRule = /(?=.*[a-z])(?=.*[A-Z])/.test(value);
        const numberRule = /(?=.*[0-9])/.test(value);
        this.setState({
            caseRule,
            minCharsRule,
            numberRule,
            value,
        });
    };

    render() {
        const { i18n, name = 'password', label = i18n.t('password'), customLabel } = this.props;
        const { minCharsRule, caseRule, numberRule, value } = this.state;
        const isGoodPassword = value.length > 0 ? minCharsRule && caseRule && numberRule : undefined;

        return (
            <div>
                {customLabel}
                <Field label={!customLabel ? label : undefined} name={name}>
                    <Password isValid={isGoodPassword} autoComplete="new-password" onChange={this.onChange} />
                </Field>
                <PasswordTextRule isDirty={!minCharsRule} size="extra-small">
                    {i18n.t('MIN_CHARS_RULE')},{' '}
                </PasswordTextRule>
                <PasswordTextRule isDirty={!caseRule} size="extra-small">
                    {i18n.t('CASE_RULE')},{' '}
                </PasswordTextRule>
                <PasswordTextRule isDirty={!numberRule} size="extra-small">
                    {i18n.t('NUMBER_RULE')}
                </PasswordTextRule>
            </div>
        );
    }
}

export default withTranslation()(CreatePassword);
